// @flow
import styled from 'styled-components';
import { smp200, smp800, smp900, neutralWhite } from '../../../colors';
/*::
import type { Node } from 'react';

export type ShipaMallThemeType = {|
  Button: * => Node,
  Icon: * => Node,
  Title: * => Node,
|};
*/

var theme
/*: ShipaMallThemeType */
= {
  Button: styled.div.withConfig({
    displayName: "theme__Button",
    componentId: "sc-2tmkqf-0"
  })(["height:4.8rem;min-width:4.8rem;width:fit-content;border-radius:10rem;display:flex;flex-direction:row;align-items:center;background-color:", ";padding:1.5rem ", "rem;cursor:", ";&:hover{background-color:", ";", ";}"], function (pr) {
    return pr.disabled ? smp200() : smp800();
  }, function (pr) {
    return pr.isChildren ? 2.4 : 1.5;
  }, function (pr) {
    return pr.disabled || pr.loading ? 'not-allowed' : 'pointer';
  }, function (pr) {
    return pr.disabled || pr.loading ? null : smp900();
  }, function (pr) {
    return pr.disabled || pr.loading ? null : 'box-shadow: 0 0.4rem 0.4rem rgba(0, 0, 0, 0.25)';
  }),
  Icon: styled.img.withConfig({
    displayName: "theme__Icon",
    componentId: "sc-2tmkqf-1"
  })(["width:1.6rem;height:1.6rem;margin-left:", "rem;margin-right:", "rem;"], function (pr) {
    return pr.position === 'right' && pr.isChildren ? 1.1 : 0;
  }, function (pr) {
    return pr.position === 'left' && pr.isChildren ? 1.1 : 0;
  }),
  Title: styled.span.withConfig({
    displayName: "theme__Title",
    componentId: "sc-2tmkqf-2"
  })(["font-size:1.8rem;font-family:'Futura PT';text-transform:uppercase;color:", ";"], neutralWhite())
};
export default theme;